import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { pageDetailLoad } from 'store/models/page';
import { DetailLoadComponent } from 'components/common';

const PageValue = (props) => {
  return (
    <DetailLoadComponent
      apiLoad={pageDetailLoad(props.site.activeDomain)}
      {...props}
      getDetailUrl={(id, item) => props.model.urls.detail(id)}
      render={({ id, item, linkPath }) => {
        const value = (item && item.path) || id;

        return (
          <Fragment>{props.asLink && linkPath ? <Link to={linkPath}>{value}</Link> : <span>{value}</span>}</Fragment>
        );
      }}
    />
  );
};

const mapState = (state) => ({
  router: state.router,
  authToken: state.auth.token,
  model: state.page,
  site: state.site,
});

export default connect(mapState)(PageValue);
